import React, { useState } from "react";
import PageHero from "./PageHero";
import img13 from "../../media/images/garary/g29.jpg";
import img14 from "../../media/images/garary/Swimming.jpg";
import img15 from "../../media/images/garary/FH_UG-689.jpg";
import img16 from "../../media/images/garary/FH_UG-869.jpg";
import img17 from "../../media/images/garary/FH_UG-485.jpg";
import img18 from "../../media/images/garary/g10.jpg";
import img19 from "../../media/images/garary/FH_UG-665.jpg";
import { Modal, Button } from "react-bootstrap";
import { FaUsers, FaGlassCheers, FaMicrophone } from "react-icons/fa";

function Events() {
  const [show, setShow] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleClose = () => setShow(false);

  const handleShow = (event) => {
    setSelectedEvent(event);
    setShow(true);
  };

  // ✅ DIFFERENT IMAGES
  const images = [img13, img14, img15, img16, img17, img18];

  const events = [
    {
      title: "Conference Hall",
      date: "Available Daily",
      capacity: "200 People",
      desc: "Perfect venue for conferences and corporate meetings.",
      icon: <FaUsers />,
    },
    {
      title: "Wedding Events",
      date: "Booking Open",
      capacity: "300 People",
      desc: "Celebrate your special day in a beautiful environment.",
      icon: <FaGlassCheers />,
    },
    {
      title: "Seminars & Workshops",
      date: "Flexible Schedule",
      capacity: "100 People",
      desc: "Ideal space for training and seminars.",
      icon: <FaMicrophone />,
    },
  ];

  return (
    <>
      {/* HERO */}
      <PageHero
        title="Events"
        subtitle="Discover upcoming events at Father’s House Church Resort Hotel"
        image={img13}
      />

      {/* INTRO */}
      <div className="container py-5 text-center">
        <h2 data-aos="fade-up">Host Your Event With Us</h2>
        <p data-aos="fade-up" className="mt-3">
          From conferences to weddings, we provide the perfect environment
          for memorable events.
        </p>
      </div>

      {/* EVENT CARDS */}
      <div className="container pb-5">
        <div className="row">
          {events.map((event, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="card shadow h-100 text-center p-4">
                <div className="text-success mb-3" style={{ fontSize: "40px" }}>
                  {event.icon}
                </div>

                <h5>{event.title}</h5>
                <p className="text-muted small">{event.date}</p>
                <p className="text-success">{event.capacity}</p>
                <p>{event.desc}</p>

                <Button variant="success" onClick={() => handleShow(event)}>
                  Book Event
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* EVENT GALLERY */}
      <div className="container py-5">
        <h2 className="text-center mb-4" data-aos="fade-up">
          Event Gallery
        </h2>

        <div className="row">
          {images.map((img, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div
                className="gallery-item"
                onClick={() => setCurrentIndex(index)}
              >
                <img
                  src={img}
                  alt="Event"
                  className="img-fluid rounded shadow"
                />

                <div className="overlay">
                  <span>View</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* EVENT HIGHLIGHT */}
      <div className="container py-5">
        <div className="row align-items-center">
          <div className="col-md-6 mb-4" data-aos="fade-right">
            <img
              src={img19}
              alt="Event Highlight"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-6" data-aos="zoom-in">
            <h2>Perfect Venue for Every Occasion</h2>
            <p className="mt-3">
              Whether it's a wedding, conference, or seminar, our venue provides
              a beautiful and well-equipped environment to make your event successful.
            </p>

            <ul>
              <li>Spacious halls</li>
              <li>Modern sound systems</li>
              <li>Professional event support</li>
            </ul>

            <button className="btn btn-success mt-3">
              Book Your Event
            </button>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div
        className="text-white text-center py-5"
        style={{
          backgroundImage: `url(${img13})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div style={{ background: "rgba(0,0,0,0.6)", padding: "40px" }}>
          <h2 data-aos="fade-up">Plan Your Next Event Today</h2>
          <p data-aos="fade-up" className="mt-2">
            Contact us to organize your perfect event.
          </p>
          <Button variant="success" onClick={() => handleShow(events[0])}>
            Book Now
          </Button>
        </div>
      </div>

      {/* BOOKING MODAL */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedEvent ? selectedEvent.title : "Event"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedEvent && (
            <>
              <p className="text-success">{selectedEvent.capacity}</p>
              <p>{selectedEvent.desc}</p>

              <h6 className="mt-3">Book This Event</h6>

              <form>
                <div className="mb-2">
                  <label className="form-label">Full Name</label>
                  <input type="text" className="form-control" />
                </div>

                <div className="mb-2">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" />
                </div>

                <div className="mb-2">
                  <label className="form-label">Event Date</label>
                  <input type="date" className="form-control" />
                </div>

                <div className="mb-2">
                  <label className="form-label">Number of Guests</label>
                  <input type="number" className="form-control" />
                </div>
              </form>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success">Confirm Booking</Button>
        </Modal.Footer>
      </Modal>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div
          className="lightbox"
          onClick={() => setCurrentIndex(null)}
        >
          {/* PREV */}
          <button
            className="nav-btn left"
            onClick={(e) => {
              e.stopPropagation();
              setCurrentIndex((prev) =>
                prev === 0 ? images.length - 1 : prev - 1
              );
            }}
          >
            ❮
          </button>

          {/* IMAGE */}
          <img src={images[currentIndex]} alt="Preview" />

          {/* NEXT */}
          <button
            className="nav-btn right"
            onClick={(e) => {
              e.stopPropagation();
              setCurrentIndex((prev) =>
                (prev + 1) % images.length
              );
            }}
          >
            ❯
          </button>
        </div>
      )}
    </>
  );
}

export default Events;